import Axios from "axios";

const api = Axios.create({
  baseURL: process.env.REACT_APP_CATALOG_API_URL,
  timeout: 15000,
});

export default api;
